
(function () {
  'use strict';
  if (window.BNToast) return;

  function bnDir(el) { return getComputedStyle(el || document.documentElement).direction === 'rtl' ? -1 : 1; }

  var ICONS = {
    success: '<svg viewBox="0 0 24 24"><path d="M4.5 12.5l5 5 10-11"/></svg>',
    error:   '<svg viewBox="0 0 24 24"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg>',
    warning: '<svg viewBox="0 0 24 24"><path d="M12 4.8 3.4 19.2h17.2z"/><path d="M12 10.2v4.1"/><path d="M12 17.1h.01"/></svg>',
    info:    '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.6"/><path d="M12 11.2v5"/><path d="M12 7.9h.01"/></svg>',

    auth:    '<svg viewBox="0 0 24 24"><path d="M18.5 19.2a6.5 6.5 0 0 0-13 0"/><circle cx="12" cy="8.2" r="3.6"/></svg>',
    mail:    '<svg viewBox="0 0 24 24"><rect x="3.2" y="5.6" width="17.6" height="12.8" rx="2.2"/><path d="m3.9 7 8.1 5.7L20.1 7"/></svg>',

    heart:   '<svg viewBox="0 0 24 24"><path d="M12 20.2S3.6 15 3.6 9.5a4.6 4.6 0 0 1 8.4-2.6 4.6 4.6 0 0 1 8.4 2.6c0 5.5-8.4 10.7-8.4 10.7Z"/></svg>',
    book:    '<svg viewBox="0 0 24 24"><path d="M12 7.4v11.9"/><path d="M12 7.4C10.3 6 8 5.3 4.4 5.3v11.9c3.6 0 5.9.7 7.6 2.1"/><path d="M12 7.4c1.7-1.4 4-2.1 7.6-2.1v11.9c-3.6 0-5.9.7-7.6 2.1"/></svg>',
    shelf:   '<svg viewBox="-93.52 -105.97 980.00 980.00" data-solid><path d="M 174.847 37.703 C 185.425 37.703 195.570 41.906 203.050 49.386 C 210.531 56.867 214.730 67.011 214.730 77.589 L 214.730 688.582 C 214.730 699.164 210.531 709.308 203.050 716.789 C 195.570 724.265 185.425 728.468 174.847 728.468 C 164.269 728.468 154.121 724.265 146.644 716.789 C 139.164 709.308 134.960 699.164 134.960 688.582 L 134.960 77.589 C 134.960 67.011 139.164 56.867 146.644 49.386 C 154.121 41.906 164.269 37.703 174.847 37.703 Z M 174.847 37.703"/><path d="M 291.332 267.324 C 301.910 267.324 312.054 271.527 319.535 279.007 C 327.015 286.488 331.218 296.632 331.218 307.210 L 331.218 688.582 C 331.218 699.164 327.015 709.308 319.535 716.789 C 312.054 724.265 301.910 728.468 291.332 728.468 C 280.753 728.468 270.609 724.265 263.128 716.789 C 255.648 709.308 251.445 699.164 251.445 688.582 L 251.445 307.210 C 251.445 296.632 255.648 286.488 263.128 279.007 C 270.609 271.527 280.753 267.324 291.332 267.324 Z M 291.332 267.324"/><path d="M 392.312 192.359 C 402.875 191.761 413.242 195.382 421.132 202.425 C 429.023 209.472 433.792 219.363 434.390 229.925 L 460.230 685.960 C 460.832 696.523 457.210 706.890 450.164 714.781 C 443.121 722.671 433.226 727.441 422.667 728.039 C 412.105 728.636 401.738 725.015 393.847 717.972 C 385.957 710.925 381.187 701.035 380.589 690.472 L 354.746 234.437 C 354.148 223.875 357.769 213.507 364.816 205.617 C 371.859 197.726 381.75 192.957 392.312 192.359 Z M 392.312 192.359"/><path d="M 490.109 234.566 C 500.277 231.640 511.187 232.875 520.445 237.996 C 529.699 243.117 536.542 251.703 539.468 261.871 L 656.316 668.085 C 659.242 678.25 658.007 689.164 652.886 698.417 C 647.765 707.675 639.179 714.519 629.011 717.441 C 618.847 720.367 607.933 719.132 598.679 714.011 C 589.421 708.890 582.578 700.304 579.656 690.136 L 462.804 283.921 C 459.878 273.757 461.113 262.847 466.234 253.589 C 471.355 244.332 479.941 237.488 490.109 234.566 Z M 490.109 234.566"/></svg>',
    scan:    '<svg viewBox="0 0 24 24"><path d="M4 8.4V6a2 2 0 0 1 2-2h2.4M20 8.4V6a2 2 0 0 0-2-2h-2.4M4 15.6V18a2 2 0 0 0 2 2h2.4M20 15.6V18a2 2 0 0 1-2 2h-2.4"/><path d="M4 12h16"/></svg>',

    cart:    '<svg viewBox="0 0 24 24"><path d="M3.4 4.6h2.3l2.2 10.2h9.3l2-7.3H6.6"/><circle cx="9.6" cy="18.6" r="1.5"/><circle cx="16.8" cy="18.6" r="1.5"/></svg>',
    tag:     '<svg viewBox="0 0 24 24"><path d="M4.6 11.5V5.2a.6.6 0 0 1 .6-.6h6.3a1 1 0 0 1 .7.3l7.2 7.2a1 1 0 0 1 0 1.4l-6 6a1 1 0 0 1-1.4 0l-7.2-7.2a1 1 0 0 1-.2-.8Z"/><path d="M8.6 8.6h.01"/></svg>',
    gift:    '<svg viewBox="0 0 24 24"><rect x="3.6" y="9.6" width="16.8" height="10.2" rx="1.6"/><path d="M3.6 13.4h16.8M12 9.6v10.2"/><path d="M12 9.6S10.7 4.6 8.3 4.6a2 2 0 0 0 0 5Zm0 0s1.3-5 3.7-5a2 2 0 0 1 0 5Z"/></svg>',
    receipt: '<svg viewBox="0 0 24 24"><path d="M5.6 3.8h12.8v16.4l-2.6-1.6-2.6 1.6-2.6-1.6-2.6 1.6-2.4-1.6z"/><path d="M9 8.6h6M9 12.4h6"/></svg>',

    parcel:  '<svg viewBox="0 0 24 24"><path d="M20.2 8.4v7.2a1.4 1.4 0 0 1-.7 1.2l-6.8 3.8a1.4 1.4 0 0 1-1.4 0l-6.8-3.8a1.4 1.4 0 0 1-.7-1.2V8.4"/><path d="m3.8 8.4 8-4.4 8.4 4.4-8.4 4.6z"/><path d="M11.8 13v7.2"/></svg>',
    truck:   '<svg viewBox="0 0 24 24"><path d="M2.8 6.4h10.4v9.8H2.8z"/><path d="M13.2 10h3.6l3.4 3.2v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>',
    clock:   '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.6"/><path d="M12 7.4V12l3.2 2"/></svg>',
    bell:    '<svg viewBox="0 0 24 24"><path d="M18 15.6V10a6 6 0 1 0-12 0v5.6l-1.5 2.2h15z"/><path d="M10 20.4a2.2 2.2 0 0 0 4 0"/></svg>',

    link:    '<svg viewBox="0 0 24 24"><path d="M10.4 13.6a3.6 3.6 0 0 0 5.2 0l2.8-2.8a3.7 3.7 0 0 0-5.2-5.2l-1.5 1.5"/><path d="M13.6 10.4a3.6 3.6 0 0 0-5.2 0l-2.8 2.8a3.7 3.7 0 0 0 5.2 5.2l1.5-1.5"/></svg>',
    copy:    '<svg viewBox="0 0 24 24"><rect x="8.6" y="8.6" width="11.2" height="11.2" rx="2"/><path d="M15.4 5.4H6.2a1.8 1.8 0 0 0-1.8 1.8v9.2"/></svg>',
    trash:   '<svg viewBox="0 0 24 24"><path d="M4.6 6.8h14.8"/><path d="M9.4 6.8V5a1.4 1.4 0 0 1 1.4-1.4h2.4A1.4 1.4 0 0 1 14.6 5v1.8"/><path d="M6.6 6.8 7.6 19a1.6 1.6 0 0 0 1.6 1.4h5.6A1.6 1.6 0 0 0 16.4 19l1-12.2"/></svg>',
    spark:   '<svg viewBox="0 0 24 24"><path d="M12 3.6 13.9 9.4 19.8 11.3 13.9 13.2 12 19 10.1 13.2 4.2 11.3 10.1 9.4Z"/><path d="M18.4 4.2v3M16.9 5.7h3"/></svg>',
    store:   '<svg viewBox="0 0 24 24"><path d="M4 10.2v9h16v-9"/><path d="M3.2 10.2 5 4.8h14l1.8 5.4a2.6 2.6 0 0 1-4.8 1.4 2.6 2.6 0 0 1-4.6 0 2.6 2.6 0 0 1-4.6 0 2.6 2.6 0 0 1-4.6-1.4Z"/></svg>'
  };

  var DEFAULT_DURATION = { auth: 6000, success: 4500, error: 5000, warning: 5500, info: 4000, neutral: 4000 };

  var el = null,
      timer = null,
      timerEndsAt = 0,
      timerLeft = 0,
      hoverBound = false,
      leaveTimer = null,
      docClick = null,
      keyDown = null,
      scroll = null,
      ctaHandler = null;

  var CAN_POPOVER = typeof HTMLElement !== 'undefined' &&
                    typeof HTMLElement.prototype.showPopover === 'function';

  function topModalDialog() {
    var open = document.querySelectorAll('dialog[open]');
    var found = null;
    for (var i = 0; i < open.length; i++) {
      var d = open[i], modal = true;
      try { modal = d.matches(':modal'); } catch (e) { modal = true; }
      if (modal) found = d;
    }
    return found;
  }

  function lower(t) {
    if (!t) return;
    if (t.hasAttribute('popover')) {
      try { if (t.matches(':popover-open')) t.hidePopover(); } catch (e) {}
      t.removeAttribute('popover');
    }
    if (t.parentElement !== document.body) document.body.appendChild(t);
  }

  function raise(t) {
    var host = topModalDialog();
    if (!host) { lower(t); return; }
    if (CAN_POPOVER) {
      if (t.parentElement !== document.body) document.body.appendChild(t);
      if (t.getAttribute('popover') !== 'manual') t.setAttribute('popover', 'manual');
      try { if (!t.matches(':popover-open')) t.showPopover(); } catch (e) {}
      return;
    }
    if (t.hasAttribute('popover')) t.removeAttribute('popover');
    if (t.parentElement !== host) host.appendChild(t);
  }

  function build() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'bn-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="bn-toast__chip" aria-hidden="true"></div>' +
      '<div class="bn-toast__body">' +
        '<div class="bn-toast__title"></div>' +
        '<div class="bn-toast__sub"></div>' +
      '</div>' +
      '<a class="bn-toast__cta"></a>';
    if (bnDir() === -1) {
      el.querySelector('.bn-toast__title').dir = 'auto';
      el.querySelector('.bn-toast__sub').dir = 'auto';
    }
    document.body.appendChild(el);
    return el;
  }

  function detach() {
    if (docClick) { try { document.removeEventListener('click', docClick, true); } catch (e) {} docClick = null; }
    if (keyDown)  { try { document.removeEventListener('keydown', keyDown); } catch (e) {} keyDown = null; }
    if (scroll)   { try { window.removeEventListener('scroll', scroll); } catch (e) {} scroll = null; }
  }

  function hide() {
    clearTimer();
    timerLeft = 0;
    detach();
    if (!el) return;
    if (el.classList.contains('is-visible')) {
      el.classList.remove('is-visible');
      el.classList.add('is-leaving');
      if (leaveTimer) clearTimeout(leaveTimer);
      leaveTimer = setTimeout(function () {
        if (el) { el.classList.remove('is-leaving'); lower(el); }
        leaveTimer = null;
      }, 360);
    } else {
      el.classList.remove('is-visible');
      el.classList.remove('is-leaving');
      lower(el);
    }
  }

  function clearTimer() {
    if (timer) { clearTimeout(timer); timer = null; }
  }
  function startTimer(ms) {
    clearTimer();
    if (!(ms > 0)) { timerEndsAt = 0; timerLeft = 0; return; }
    timerLeft = ms;
    timerEndsAt = Date.now() + ms;
    timer = setTimeout(hide, ms);
  }
  function pauseTimer() {
    if (!timer) return;
    timerLeft = Math.max(0, timerEndsAt - Date.now());
    clearTimer();
  }
  function resumeTimer() {
    if (timer || !(timerLeft > 0)) return;
    if (!el || !el.classList.contains('is-visible')) return;
    startTimer(timerLeft);
  }
  function bindHover(t) {
    if (hoverBound) return;
    hoverBound = true;
    t.addEventListener('mouseenter', pauseTimer);
    t.addEventListener('mouseleave', resumeTimer);
    t.addEventListener('focusin', pauseTimer);
    t.addEventListener('focusout', resumeTimer);
  }

  function fitShape(t, titleEl) {
    t.classList.remove('bn-toast--block');
    if (!titleEl) return;
    var lh = parseFloat(getComputedStyle(titleEl).lineHeight);
    if (!(lh > 0)) return;
    if (titleEl.getBoundingClientRect().height > lh * 1.5) {
      t.classList.add('bn-toast--block');
    }
  }

  function resolveIcon(icon, variant) {
    if (typeof icon === 'string' && icon) {
      if (icon.charAt(0) === '<') return icon;
      if (ICONS[icon]) return ICONS[icon];
    }
    return ICONS[variant] || ICONS.info;
  }

  function show(opts) {
    opts = opts || {};
    var variant = opts.variant || 'info';
    var t = build();

    t.className = 'bn-toast bn-variant-' + variant + (opts.wide ? ' bn-toast--wide' : '');
    if (opts.accent) t.style.setProperty('--bn-toast-accent', opts.accent);
    else t.style.removeProperty('--bn-toast-accent');

    var urgent = opts.urgent != null ? opts.urgent : (variant === 'error');
    t.setAttribute('role', urgent ? 'alert' : 'status');
    t.setAttribute('aria-live', urgent ? 'assertive' : 'polite');

    t.querySelector('.bn-toast__chip').innerHTML = resolveIcon(opts.icon, variant);

    var titleEl = t.querySelector('.bn-toast__title');
    var subEl = t.querySelector('.bn-toast__sub');
    titleEl.textContent = opts.title == null ? '' : String(opts.title);
    if (opts.sub) {
      subEl.textContent = String(opts.sub);
      subEl.style.display = '';
      t.classList.add('bn-has-sub');
    } else {
      subEl.textContent = '';
      subEl.style.display = 'none';
      t.classList.remove('bn-has-sub');
    }

    var ctaEl = t.querySelector('.bn-toast__cta');
    if (ctaHandler) { ctaEl.removeEventListener('click', ctaHandler); ctaHandler = null; }
    var cta = opts.cta || null;
    if (cta && cta.label) {
      ctaEl.innerHTML = '';
      if (cta.icon) ctaEl.insertAdjacentHTML('beforeend', cta.icon);
      var ctaLabel = document.createElement('span');
      ctaLabel.textContent = cta.label;
      if (bnDir() === -1) ctaLabel.dir = 'auto';
      ctaEl.appendChild(ctaLabel);
      ctaEl.style.display = '';
      ctaEl.className = 'bn-toast__cta' + (cta.ghost ? ' bn-cta-ghost' : '');
      t.classList.add('bn-has-cta');
      if (typeof cta.href === 'function') {
        ctaEl.setAttribute('href', '#');
        ctaHandler = function () { try { ctaEl.setAttribute('href', cta.href()); } catch (e) {} };
        ctaEl.addEventListener('click', ctaHandler);
      } else if (cta.href) {
        ctaEl.setAttribute('href', cta.href);
      } else if (typeof cta.onClick === 'function') {
        ctaEl.setAttribute('href', '#');
        ctaHandler = function (e) {
          e.preventDefault();
          try { cta.onClick(); } catch (err) {}
          hide();
        };
        ctaEl.addEventListener('click', ctaHandler);
      }
    } else {
      ctaEl.innerHTML = '';
      ctaEl.style.display = 'none';
      ctaEl.className = 'bn-toast__cta';
      ctaEl.setAttribute('href', '#');
      t.classList.remove('bn-has-cta');
    }

    var duration = opts.duration != null ? opts.duration : (DEFAULT_DURATION[variant] || 4500);

    detach();
    clearTimer();
    if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
    t.classList.remove('is-visible');
    t.classList.remove('is-leaving');
    raise(t);
    fitShape(t, titleEl);
    void t.offsetHeight;
    t.classList.add('is-visible');

    var focusCta = opts.focusCta != null ? opts.focusCta : (variant === 'auth');
    if (focusCta && cta && cta.label) {
      setTimeout(function () {
        try { ctaEl.focus({ preventScroll: true }); } catch (e) { try { ctaEl.focus(); } catch (e2) {} }
      }, 200);
    }

    bindHover(t);
    startTimer(duration);

    var dismiss = opts.dismiss || (variant === 'auth' ? { outside: true, escape: true, scroll: true } : {});
    if (dismiss.outside || dismiss.escape || dismiss.scroll) {
      if (dismiss.outside) docClick = function (e) { if (el && el.contains(e.target)) return; hide(); };
      if (dismiss.escape)  keyDown  = function (e) { if (e.key === 'Escape' || e.keyCode === 27) hide(); };
      if (dismiss.scroll)  scroll   = function () { hide(); };
      setTimeout(function () {
        if (docClick) document.addEventListener('click', docClick, true);
        if (keyDown)  document.addEventListener('keydown', keyDown);
        if (scroll)   window.addEventListener('scroll', scroll, { passive: true });
      }, 150);
    }

    return t;
  }

  window.BNToast = { show: show, hide: hide, icons: ICONS };
})();
